import Vue from 'vue'
Vue.prototype.$perHelper = function (permission) {
  return true
}
